<svelte:options tag={null} />

<script lang="ts">
  export let visible = false;
</script>

<div class="mc-overlay" class:is-visible={visible} {...$$restProps}>
  <!-- @slot Use this slot to insert a centered content inside the overlay -->
  <slot />
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.overlay';
</style>
